import { createUseData } from "../../../../../../../common/hooks/create-use-data/create-use-data";
import { service } from "./demo-dashboard-nav-link.service";

export const useDashboardLink = createUseData(service.getDemoDashboardLink)